// @ts-nocheck
import { Routes, Route } from 'react-router-dom';
import RegisterOverview from './RegisterOverview';
// Renamed variants
import RegisterClassicMinimal from './RegisterClassicMinimal';
import RegisterHeroImage from './RegisterHeroImage';
import RegisterDarkMode from './RegisterDarkMode';
// Existing variants
import RegisterSplit from './RegisterSplit';
import RegisterGradient from './RegisterGradient';
import RegisterModern from './RegisterModern';
import RegisterAnimated from './RegisterAnimated';
import RegisterIllustrated from './RegisterIllustrated';
import RegisterParallax from './RegisterParallax';
import RegisterMinimal3D from './RegisterMinimal3D';
import RegisterSplitScreen from './RegisterSplitScreen';
// New variants
import RegisterCenteredCard from './RegisterCenteredCard';
import RegisterGlassmorphism from './RegisterGlassmorphism';
import RegisterMobileAppStyle from './RegisterMobileAppStyle';
import RegisterSocialLogin from './RegisterSocialLogin';
import RegisterSidebar from './RegisterSidebar';
import RegisterCarouselOnboarding from './RegisterCarouselOnboarding';

export default function RegisterRoutes() {
  return (
    <Routes>
      <Route index element={<RegisterOverview />} />
      {/* Renamed routes */}
      <Route path="classic-minimal" element={<RegisterClassicMinimal />} />
      <Route path="hero-image" element={<RegisterHeroImage />} />
      <Route path="dark-mode" element={<RegisterDarkMode />} />
      {/* Existing routes */}
      <Route path="split" element={<RegisterSplit />} />
      <Route path="gradient" element={<RegisterGradient />} />
      <Route path="modern" element={<RegisterModern />} />
      <Route path="animated" element={<RegisterAnimated />} />
      <Route path="illustrated" element={<RegisterIllustrated />} />
      <Route path="parallax" element={<RegisterParallax />} />
      <Route path="minimal3d" element={<RegisterMinimal3D />} />
      <Route path="splitscreen" element={<RegisterSplitScreen />} />
      {/* New routes */}
      <Route path="centered-card" element={<RegisterCenteredCard />} />
      <Route path="glassmorphism" element={<RegisterGlassmorphism />} />
      <Route path="mobile-app-style" element={<RegisterMobileAppStyle />} />
      <Route path="social-login" element={<RegisterSocialLogin />} />
      <Route path="sidebar" element={<RegisterSidebar />} />
      <Route path="carousel-onboarding" element={<RegisterCarouselOnboarding />} />
    </Routes>
  );
}
